import { VoiceDemoProvider } from '../../providers/VoiceDemoContext';
import { useVoices } from '../../providers/VoicesProvider';

import { VoiceDemo } from './VoiceDemo';
import { VoiceDemoSkeleton } from './VoiceDemoSkeleton';

export const VoiceDemoRoot = () => {
  const { loading } = useVoices();

  if (loading) {
    return (
      <div className="studio-vo-demo-styling">
        <div className="flex justify-center @container">
          <VoiceDemoSkeleton />
        </div>
      </div>
    );
  }

  return (
    <VoiceDemoProvider>
      <div className="studio-vo-demo-styling">
        <div className="flex justify-center @container">
          <VoiceDemo />
        </div>
      </div>
    </VoiceDemoProvider>
  );
};
